import { Flex, Spinner } from '@chakra-ui/react';

const FullPageLoader = () => <Flex
  w="100vw"
  h="100vh"
  bg="rgba(255,255,255,1)"
  alignItems="center"
  justifyContent="center"
  position={"fixed"}
  top="0"
  left="0"
  right="0"
  bottom="0"
  zIndex={999999}
>
  <Spinner
    thickness="4px"
    speed="0.65s"
    emptyColor="white"
    color="#11365f"
    size="xl"
  />
</Flex>
export default FullPageLoader;